<template lang="pug">
.file-list(:class="{ hover: hover }")
  .file-item(v-for="(file, i) in fileList", :title="file.fileName", :key="i")
    .file-process(v-if="file.$process", :style="{ width: file.$process + '%' }")
    .file-btns
      .file-size(v-if="file.fileSize") {{ file.fileSize | fileSize }}
      slot(name="btns", :file="file", :fileList="fileList")
      i.el-icon-download(v-if="file.$url", @click.stop="$emit('download', file)")
      i.el-icon-delete(v-if="file.$delete", @click.stop="$emit('delete', file, fileList)")
    .file-icon
      img(v-file="file")
    .file-name(@click="$emit('preview', file)") {{ file.fileName }}
</template>
<script>
import { fileDirective, fileSize } from "./file";
export default {
  directives: { file: fileDirective },
  filters: { fileSize },
  props: {
    hover: { default: true, type: Boolean },
    fileList: { default: () => [], type: Array }
  }
};
</script>
<style lang="scss" scoped src="./index.scss" />
